import React, { useState, useEffect, useRef } from "react";
import { sendMessage, getMessages, markMessagesAsRead,deleteMessage , editMessage } from "../Apis/ChatApis";
import { viewAllAdmins } from "../Apis/SuperadminApis";
import { GoReply } from "react-icons/go";
import { MdContentCopy } from "react-icons/md";
import { FiCornerUpRight } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineEdit } from "react-icons/md";
import { FaTimes } from "react-icons/fa";
import { FiSend } from "react-icons/fi";

const MessageBox = React.forwardRef(({ selectedChat, userRole, onMessageSent, onMessagesRead }, ref) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const messagesEndRef = useRef(null);
  const fileInputRef = useRef(null);
  const currentUserName = sessionStorage.getItem("adminName");
  const isGroupChat = selectedChat?.type === "group";
  const [expandedMessages, setExpandedMessages] = useState({});

const toggleExpandMessage = (id, fullLength) => {
  setExpandedMessages((prev) => {
    const current = prev[id] || 400;

    if (current >= fullLength) {
      return {
        ...prev,
        [id]: 400
      };
    }

    const next = current + 2000;

    return {
      ...prev,
      [id]: next >= fullLength ? fullLength : next
    };
  });
};
React.useImperativeHandle(ref, () => ({
  addNewMessage: (newMessage) => {
    const formattedMessage = {
      id: newMessage.id,
      message: newMessage.message || "",
      sender: newMessage.sender || "Unknown",
      file_url: newMessage.file_url || null,
      created_on: newMessage.created_on || new Date().toISOString(),
      is_edited: false,
      reply_to_message: newMessage.reply_to_message || null,
      reply_to_message_text: newMessage.reply_to_message_text || null,
      reply_to_sender_name: newMessage.reply_to_sender_name || null,
      is_group: newMessage.is_group || false,
    };

    setMessages((prevMessages) => {
      const exists = prevMessages.some((msg) => msg.id === formattedMessage.id);
      if (exists) return prevMessages;
      return [...prevMessages, formattedMessage];
    });

    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  },

  updateEditedMessage: (updated) => {
    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.id === updated.id
          ? {
              ...msg,
              message: updated.message,
              is_edited: true,
              updated_on: updated.updated_on,
            }
          : msg
      )
    );
  },

  removeDeletedMessages: (deletedIds) => {

    setMessages((prevMessages) =>
      prevMessages.filter(
        (msg) => !deletedIds.includes(msg.id)
      )
    );
  }

}));

  const isFirstLoad = useRef(true);

const [contextMenu, setContextMenu] = useState({ show: false, x: 0, y: 0, message: null });
const [replyingTo, setReplyingTo] = useState(null);
const [editModal, setEditModal] = useState({ show: false, message: null, text: "" });
const [deleteModal, setDeleteModal] = useState({ show: false, message: null });
const [forwardModal, setForwardModal] = useState({ show: false, message: null });
const [contacts, setContacts] = useState([]);
const [searchTerm, setSearchTerm] = useState("");
const [isForwarding, setIsForwarding] = useState(false);
const [selectMode, setSelectMode] = useState(false);
const [selectedMessages, setSelectedMessages] = useState(new Set());
const [showBulkDeleteConfirm, setShowBulkDeleteConfirm] = useState(false);
const toggleSelectMode = () => {
  setSelectMode(!selectMode);
  setSelectedMessages(new Set());  
};

const toggleMessageSelection = (messageId) => {
  const newSelected = new Set(selectedMessages);
  if (newSelected.has(messageId)) {
    newSelected.delete(messageId);
  } else {
    newSelected.add(messageId);
  }
  setSelectedMessages(newSelected);
    if (newSelected.size === 0) {
    setSelectMode(false);
  }
};

const handleBulkDelete = () => {
  if (selectedMessages.size === 0) {
    alert("Please select at least one message to delete");
    return;
  }
  setShowBulkDeleteConfirm(true);
};

const confirmBulkDelete = async () => {
  try {
    const messageIds = Array.from(selectedMessages);
    const response = await deleteMessage({ message_ids: messageIds });
    
    if (response.message === "Deleted successfully" || response.deleted_count > 0) {
      setMessages(prevMessages => 
        prevMessages.filter(msg => !selectedMessages.has(msg.id))
      );
      setSelectedMessages(new Set());
      setSelectMode(false);
      setShowBulkDeleteConfirm(false);
    } else {
      alert(response.error || "Failed to delete messages");
    }
  } catch (error) {
    console.error("Failed to delete messages:", error);
    alert("Failed to delete messages. Please try again.");
  }
};

const cancelBulkDelete = () => {
  setShowBulkDeleteConfirm(false);
};


const [forwardMode, setForwardMode] = useState(false);
const [forwardSelectedMessages, setForwardSelectedMessages] = useState(new Set());

const [selectedContacts, setSelectedContacts] = useState(new Set());


const handleMessageMenu = (e, message) => {
  e.preventDefault();
  e.stopPropagation();
  
  const rect = e.currentTarget.getBoundingClientRect();

  const isSender =
    message.sender?.toLowerCase().trim() ===
    currentUserName?.toLowerCase().trim();

  setContextMenu({
    show: true,
    x: isSender ? rect.right : rect.left,
    y: rect.bottom + 5,
    message: message,
    isSender 
  });
};

const closeContextMenu = () => {
  setContextMenu({ show: false, x: 0, y: 0, message: null });
};

const handleCopyMessage = async (message) => {
  try {
    await navigator.clipboard.writeText(message.message);
  } catch (err) {
    console.error("Failed to copy:", err);
  }
  closeContextMenu();
};

const handleEditMessage = (message) => {
  setEditModal({
    show: true,
    message: message,
    text: message.message
  });
  closeContextMenu();
};

const handleSaveEditFromModal = async () => {
  if (!editModal.text.trim()) return;
  
  try {
    const response = await editMessage({
      message_id: editModal.message.id,
      message: editModal.text
    });
    
    if (response.message === "Message updated") {
      setMessages(prevMessages => 
        prevMessages.map(msg => 
          msg.id === editModal.message.id 
            ? { ...msg, message: editModal.text, is_edited: true }
            : msg
        )
      );
      setEditModal({ show: false, message: null, text: "" });
    } else {
      alert(response.error || "Failed to edit message");
    }
  } catch (error) {
    console.error("Failed to edit message:", error);
    alert("Failed to edit message");
  }
};

const handleCancelEditModal = () => {
  setEditModal({ show: false, message: null, text: "" });
};

const handleDeleteMessage = (message) => {
  if (userRole !== "superadmin") {
    alert("Only superadmin can delete messages");
    return;
  }
  
  closeContextMenu();
  
  setSelectMode(true);
  setSelectedMessages(new Set());
  setSelectedMessages(new Set([message.id]));
  
  setTimeout(() => {
    const selectionBar = document.querySelector('.mb-selection-bar');
    if (selectionBar) {
      selectionBar.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, 100);
};

const handleConfirmDelete = async () => {
  if (!deleteModal.message) return;
  
  try {
    const response = await deleteMessage({ message_id: deleteModal.message.id });
    
    if (response.message === "Deleted successfully") {
      setMessages(prevMessages => prevMessages.filter(m => m.id !== deleteModal.message.id));
      setDeleteModal({ show: false, message: null });
    } else {
      alert(response.error || "Failed to delete message");
      setDeleteModal({ show: false, message: null });
    }
  } catch (error) {
    console.error("Failed to delete message:", error);
    alert("Failed to delete message");
    setDeleteModal({ show: false, message: null });
  }
};

const handleCancelDelete = () => {
  setDeleteModal({ show: false, message: null });
};

const handleReplyTo = (message) => {
  setReplyingTo(message);
  closeContextMenu();
  setTimeout(() => {
    const inputElement = document.querySelector('.mb-message-input');
    if (inputElement) inputElement.focus();
  }, 100);
};

const cancelReply = () => {
  setReplyingTo(null);
};

const handleForwardMessage = (message) => {
  closeContextMenu();

  setForwardMode(true);
  setForwardSelectedMessages(new Set([message.id]));  
};

const toggleForwardSelection = (messageId) => {
  const updated = new Set(forwardSelectedMessages);

  if (updated.has(messageId)) {
    updated.delete(messageId);
  } else {
    updated.add(messageId);
  }

  setForwardSelectedMessages(updated);
    if (updated.size === 0) {
    setForwardMode(false);
  }
};

const sendForwardMessage = async () => {
  if (selectedContacts.size === 0) {
    alert("Select at least one contact");
    return;
  }

  if (forwardSelectedMessages.size === 0) {
    alert("Select messages to forward");
    return;
  }

  setIsForwarding(true);

  try {
    const formData = new FormData();

    forwardSelectedMessages.forEach((id) => {
      formData.append("message_ids[]", id);
    });

    selectedContacts.forEach((contact) => {
      if (contact.type === "admin") {
        formData.append("receiver_admin_ids[]", contact.id);
      } else {
        formData.append("receiver_superadmin_ids[]", contact.id);
      }
    });

    const response = await sendMessage(formData);

    if (response.message) {
      setForwardMode(false);
      setForwardSelectedMessages(new Set());
      setSelectedContacts(new Set());
      setForwardModal({ show: false });

      await loadMessages();
    } else {
      alert(response.error || "Forward failed");
    }
  } catch (err) {
    console.error(err);
    alert("Forward failed");
  } finally {
    setIsForwarding(false);
  }
};

const filteredContacts = contacts.filter(contact =>
  (contact.name?.toLowerCase().includes(searchTerm.toLowerCase()) || false) ||
  (contact.email?.toLowerCase().includes(searchTerm.toLowerCase()) || false)
);


  const getInitial = (name) => {
  return name?.charAt(0)?.toUpperCase() || "?";
};
const getAvatarColor = (value) => {
  const colors = [
    "#4a90e2", "#50bfa0", "#f5a623",
    "#e94e77", "#9b59b6", "#34495e",
    "#ff6b6b", "#6c5ce7", "#00b894"
  ];

  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }

  return colors[Math.abs(hash) % colors.length];
};

const displayValue =
  selectedChat?.type === "superadmin"
    ? selectedChat?.email
    : selectedChat?.name;

const getFileType = (url) => {
  if (!url) return "file";
  const cleanUrl = url.split("?")[0];
  const ext = cleanUrl.split(".").pop().toLowerCase();

  if (["jpg", "jpeg", "png", "gif", "webp", "avif"].includes(ext)) return "image";
  if (ext === "pdf") return "pdf";
  if (["doc", "docx"].includes(ext)) return "doc";

  return "file";
};


 const isImage = (url) => {
  if (!url) return false;
  const cleanUrl = url.split("?")[0]; 
  return /\.(jpg|jpeg|png|gif|webp|avif)$/i.test(cleanUrl);
};

  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    if (selectedChat) {
      loadMessages();
      const interval = setInterval(loadMessages, 5000000);  
      return () => clearInterval(interval);
    }
  }, [selectedChat]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);
 
useEffect(() => {
  if (!selectedChat) return;

  const markCurrentChatAsRead = async () => {
    try {
      const payload = {};

      if (selectedChat.type === "admin") {
        payload.receiver_admin_id = selectedChat.receiver_admin_id;
      }

      if (selectedChat.type === "superadmin") {
        payload.receiver_superadmin_id =
          selectedChat.receiver_superadmin_id;
      }

      if (selectedChat.type === "group") {
        payload.is_group = true;
      }

      if (messages.length > 0) {
        payload.last_message_id =
          messages[messages.length - 1].id;
      }

      console.log("MARK READ PAYLOAD:", payload);

      const response = await markMessagesAsRead(payload);

      console.log("MARK READ RESPONSE:", response);

      if (onMessagesRead) {
        onMessagesRead();
      }

      if (onMessageSent) {
        onMessageSent();
      }

    } catch (err) {
      console.error("Failed to mark chat as read:", err);
    }
  };

  const timer = setTimeout(() => {
    markCurrentChatAsRead();
  }, 300);

  return () => clearTimeout(timer);

}, [selectedChat, messages.length]);

useEffect(() => {
  setSelectMode(false);
  setSelectedMessages(new Set());
  setShowBulkDeleteConfirm(false);
  setReplyingTo(null);
  setEditModal({ show: false, message: null, text: "" });
  setDeleteModal({ show: false, message: null });
  setForwardModal({ show: false, message: null });
  setContextMenu({ show: false, x: 0, y: 0, message: null });
  setForwardMode(false);
setForwardSelectedMessages(new Set());
setSelectedContacts(new Set());
  setSelectedFile(null);
  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
}, [selectedChat]);  


useEffect(() => {
  if (forwardModal.show) {
    fetchContacts();
  }
}, [forwardModal.show]);

const fetchContacts = async () => {
  try {
    let contactsList = [];
    
    if (userRole === "admin") {
      const response = await viewAllAdmins({ action: "superadmin" });;
      console.log("SuperAdmin API Response:", response);  
      
      if (response.superadmins && !response.error) {
        contactsList = response.superadmins.map(sa => ({
          id: sa.id,
          name: sa.name || sa.email?.split('@')[0] || "Super Admin",
          email: sa.email,
          type: "superadmin",
          avatar: (sa.name || sa.email)?.charAt(0)?.toUpperCase() || "S"
        }));
      }
    } else if (userRole === "superadmin") {
      const response = await viewAllAdmins();
      console.log("View All Admins Response:", response);  
      
      if (response.data && !response.error) {
        contactsList = response.data.map(admin => ({
          id: admin.id,
          name: admin.name || admin.contact_name || admin.email?.split('@')[0] || "Admin",
          email: admin.email,
          type: "admin",
          avatar: (admin.name || admin.contact_name || admin.email)?.charAt(0)?.toUpperCase() || "A"
        }));
      } else if (response.admins && !response.error) {
        contactsList = response.admins.map(admin => ({
          id: admin.id,
          name: admin.name || admin.email?.split('@')[0] || "Admin",
          email: admin.email,
          type: "admin",
          avatar: (admin.name || admin.email)?.charAt(0)?.toUpperCase() || "A"
        }));
      }
    }
    
    console.log("Processed Contacts:", contactsList); 
    setContacts(contactsList);
  } catch (error) {
    console.error("Failed to fetch contacts:", error);
    setContacts([]);
  }
};

const toggleContactSelection = (contact) => {
  const updated = new Set(selectedContacts);

  if ([...updated].some(c => c.id === contact.id)) {
    updated.forEach(c => {
      if (c.id === contact.id) updated.delete(c);
    });
  } else {
    updated.add(contact);
  }

  setSelectedContacts(new Set(updated));
};

const loadMessages = async () => {
  try {
    setIsLoading(true);


    const payload = {};

    if (selectedChat?.type === "admin") {
      payload.receiver_admin_id = selectedChat.receiver_admin_id;
    }

    if (selectedChat?.type === "superadmin") {
      payload.receiver_superadmin_id = selectedChat.receiver_superadmin_id;
    }

    if (selectedChat?.type === "group") {
  payload.is_group = true;
}

    const response = await getMessages(payload);

    if (response.messages) {
      setMessages(response.messages);
    }
  } catch (error) {
    console.error("Failed to load messages:", error);
  } finally {
    setIsLoading(false);
  }
};
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      const maxSize = 10 * 1024 * 1024;  
      if (file.size > maxSize) {
        alert("File size should be less than 10MB");
        return;
      }
      setSelectedFile(file);
    }
  };

const handleSendMessage = async (e) => {
  e.preventDefault();
  
  if (!newMessage.trim() && !selectedFile) {
    return;
  }

  setIsSending(true);
  
  const formData = new FormData();
  if (newMessage.trim()) {
    formData.append("message", newMessage);
  }
  if (selectedFile) {
    formData.append("file", selectedFile);
  }
  if (selectedChat?.type === "admin") {
    formData.append("receiver_admin_id", selectedChat.receiver_admin_id);
  }
  if (selectedChat?.type === "superadmin") {
    formData.append("receiver_superadmin_id", selectedChat.receiver_superadmin_id);
  }
  
  if (replyingTo) {
    formData.append("reply_to_message_id", replyingTo.id);
    formData.append("reply_to_sender", replyingTo.sender);
    formData.append("reply_to_text", replyingTo.message);
  }

  try {
    const response = await sendMessage(formData);
    
    if (response.message) {
      setNewMessage("");
      setSelectedFile(null);
      setReplyingTo(null);  
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      } 
      if (onMessageSent) {
        onMessageSent();
      }
    }
  } catch (error) {
    console.error("Failed to send message:", error);
    alert("Failed to send message. Please try again.");
  } finally {
    setIsSending(false);
  }
};

const formatTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-US', { 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: true 
  });
};

const getCollapsedText = (text, limit = 180) => {
  if (!text) return "";

  if (text.length <= limit) return text;

  return text.slice(0, limit);
};

const getDateHeader = (dateString) => {
  const date = new Date(dateString);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  
  today.setHours(0, 0, 0, 0);
  yesterday.setHours(0, 0, 0, 0);
  const messageDate = new Date(date);
  messageDate.setHours(0, 0, 0, 0);
  
  if (messageDate.getTime() === today.getTime()) {
    return "Today";
  } else if (messageDate.getTime() === yesterday.getTime()) {
    return "Yesterday";
  } else {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayName = days[date.getDay()];
    
    const weekAgo = new Date(today);
    weekAgo.setDate(today.getDate() - 7);
    
    if (messageDate >= weekAgo) {
      return dayName;
    } else {
      return date.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric', 
        year: 'numeric' 
      });
    }
  }
};


const getStatusText = (item) => {
  if (!item) return "";

  if (item.is_login) return "Online";

  if (!item.logout_on) return "Offline";

  const logout = new Date(item.logout_on.replace(" ", "T"));
  const now = new Date();

  const isToday =
    logout.getDate() === now.getDate() &&
    logout.getMonth() === now.getMonth() &&
    logout.getFullYear() === now.getFullYear();

  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  const isYesterday =
    logout.getDate() === yesterday.getDate() &&
    logout.getMonth() === yesterday.getMonth() &&
    logout.getFullYear() === yesterday.getFullYear();

  const time = logout.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  if (isToday) return `Last seen today at ${time}`;
  if (isYesterday) return `Last seen yesterday at ${time}`;

  const date = logout.toLocaleDateString([], {
    day: "2-digit",
    month: "short",
  });

  return `Last seen ${date} at ${time}`;
};

const formatNameFromEmail = (email) => {
  if (!email) return "";
  
  const namePart = email.split("@")[0];
  
  return namePart
    .replace(/([a-z])([A-Z])/g, "$1 $2") 
    .replace(/[^a-zA-Z]/g, " ")
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
    .trim() || namePart;
};

  return (
    <div className="mb-message-box">
      {!selectedChat ? (
  <div className="mb-no-chat-selected">
    <div className="mb-empty-state-modern">
      <div className="mb-empty-illustration">💬</div>

      <h2 className="mb-empty-title">
        Welcome to KFT Chat
      </h2>

      <p className="mb-empty-description">
        Select a conversation from the sidebar to start messaging.
        <br />
        Stay connected with admins and your team in real-time.
      </p>

      <div className="mb-empty-features">
        <div>✔ Real-time messaging</div>
        <div>✔ File sharing</div>
        <div>✔ Group discussions</div>
      </div>
    </div>
  </div>
) : (
        <>
<div className="mb-chat-header">
  <div className="mb-header-info">
    <div
      className="mb-chat-avatar"
      style={{ background: getAvatarColor(displayValue || "") }}
    >
      <span className="mb-avatar-icon">
        {displayValue?.charAt(0)?.toUpperCase() || "?"}
      </span>
    </div>
    <div>
      <h3 className="mb-chat-name">
        {selectedChat?.name}
      </h3>
      {selectedChat?.type !== "group" && (
        <span
          className={`mb-chat-status ${
            selectedChat?.is_login ? "mb-online" : "mb-offline"
          }`}
        >
          {getStatusText(selectedChat)}
        </span>
      )}
    </div>
  </div>
</div>

          <div className="mb-messages-container">
            {isLoading ? (
              <div className="mb-loading-container">
                <div className="mb-spinner"></div>
                <p>Loading messages...</p>
              </div>
            ) : messages.length === 0 ? (
              <div className="mb-empty-messages">
                <span className="mb-empty-emoji">💬</span>
                <p>No messages yet</p>
                <p className="mb-empty-sub">Send a message to start the conversation</p>
              </div>
            ) : (

              <div className="mb-messages-list">
  {messages.reduce((grouped, msg, index) => {
    const dateHeader = getDateHeader(msg.created_on);
    const lastGroup = grouped[grouped.length - 1];
    
    if (!lastGroup || lastGroup.date !== dateHeader) {
      grouped.push({ date: dateHeader, messages: [msg] });
    } else {
      lastGroup.messages.push(msg);
    }
    return grouped;
  }, []).map((group, groupIdx) => (
    <div key={groupIdx} className="mb-message-group">
      <div className="mb-date-header">
        <span className="mb-date-header-text">{group.date}</span>
      </div>

{group.messages.map((msg, msgIdx) => {
  const isCurrentUser = msg.sender?.toLowerCase().trim() === currentUserName?.toLowerCase().trim();
  const canEdit = isCurrentUser && !msg.file_url;
  const canDelete = userRole === "superadmin";
  const isSelected = selectedMessages.has(msg.id);
  
  return (
    <div key={msg.id || msgIdx}
      className={`mb-message-item ${
        isCurrentUser ? "mb-sent" : "mb-received"} 
        ${selectMode ? "mb-select-mode" : ""} 
      ${isSelected ? "mb-selected-message" : ""}
       ${forwardMode && forwardSelectedMessages.has(msg.id) ? "mb-selected-message" : ""}
      `}
      onClick={() => {
        if (selectMode) {
          toggleMessageSelection(msg.id);
        } else if (forwardMode) {
          toggleForwardSelection(msg.id);
        }
      }}
      onContextMenu={(e) => {
        if (!selectMode && !forwardMode) {
          handleMessageMenu(e, msg);
        }
      }}
    >
    
      {selectMode && (
        <div className="mb-message-checkbox">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => toggleMessageSelection(msg.id)}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {forwardMode && (
        <div className="mb-message-checkbox">
          <input
            type="checkbox"
            checked={forwardSelectedMessages.has(msg.id)}
            onChange={() => toggleForwardSelection(msg.id)}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
      
      {isGroupChat && !selectMode && !forwardMode && (
        <div className="mb-avatar">
          {getInitial(msg.sender)}
        </div>
      )}

   <div className="mb-message-bubble">
  <div className="mb-message-header">
    <div className="mb-message-sender">{msg.sender}</div>
    {!selectMode && !forwardMode &&(
      <button 
        className="mb-message-menu-btn"
        onClick={(e) => handleMessageMenu(e, msg)}
        title="Message options"
      >
        ⋮
      </button>
    )}
  </div>
  
  {(msg.reply_to_message || msg.reply_to || msg.reply_to_sender_name) && (
    <div className="mb-replied-context">
      <div className="mb-replied-label">
        ↪️ Replying to {(msg.reply_to_message?.sender || msg.reply_to?.sender || msg.reply_to_sender_name || "Unknown")}
      </div>
      <div className="mb-replied-text">
        {(msg.reply_to_message?.message || msg.reply_to?.message || msg.reply_to_message_text || "📎 Attachment")}
      </div>
    </div>
  )}
  
  <div className="mb-message-text">
    {(() => {
      const isForwarded = msg.message?.startsWith("Forwarded:");
      const fullText = isForwarded
        ? msg.message.replace("Forwarded:", "").trim()
        : msg.message || "";

      const limit = expandedMessages[msg.id] || 400;
      const isFullyExpanded = limit >= fullText.length;
      const displayText = fullText.slice(0, limit);

      return (
        <>
          {isForwarded && (
            <div className="mb-forward-label">
              <FiCornerUpRight size={14} /> Forwarded
            </div>
          )}
          <span>
            {displayText}
            {!isFullyExpanded && "..."}
          </span>
          {fullText.length > 400 && (
            <span
              className="mb-read-more"
              onClick={() => toggleExpandMessage(msg.id, fullText.length)}
            >
              {isFullyExpanded ? " Read less" : " Read more"}
            </span>
          )}
        </>
      );
    })()}
  </div>
  
  {msg.file_url && (
    <div className="mb-message-file">
      {getFileType(msg.file_url) === "image" ? (
        <img
          src={msg.file_url}
          alt="attachment"
          className="mb-file-image"
          onClick={() => setPreviewImage(msg.file_url)}
        />
      ) : (
        <div
          className="mb-file-preview-box"
          onClick={() => window.open(msg.file_url, "_blank")}
        >
          {getFileType(msg.file_url) === "pdf" ? (
            <iframe
              src={msg.file_url}
              title="pdf-preview"
              className="mb-file-preview-frame"
            />
          ) : (
            <div className="mb-file-fake-preview">
              {getFileType(msg.file_url) === "doc" && "DOC"}
              {getFileType(msg.file_url) === "file" && "FILE"}
            </div>
          )}
          <div className="mb-file-overlay">
            {getFileType(msg.file_url) === "pdf" ? "Preview" : "Open file"}
          </div>
        </div>
      )}
    </div>
  )}
  
  <div className="mb-message-footer">
    <div className="mb-message-time">
      {formatTime(msg.created_on)}
      {msg.is_edited && <span className="mb-edited-badge"> (edited)</span>}
    </div>
  </div>
</div>
    </div>
  );
})}

    </div>
  ))}
  <div ref={messagesEndRef} />
</div>

            )}
          </div>

 {previewImage && (
  <div
    className="mb-image-modal"
    onClick={() => setPreviewImage(null)}
  >
    {previewImage.includes(".pdf") ? (
      <iframe
        src={previewImage}
        className="mb-image-modal-content"
        title="pdf-full"
      />
    ) : (
      <img
        src={previewImage}
        alt="preview"
        className="mb-image-modal-content"
        onClick={(e) => e.stopPropagation()}
      />
    )}
  </div>
)}

{replyingTo && (
  <div className="mb-reply-indicator-bar">
    <div className="mb-reply-content">
      <div className="mb-reply-label">
        <span>↩️ Replying to {replyingTo.sender}</span>
        <button 
          className="mb-reply-cancel"
          onClick={cancelReply}
          title="Cancel reply"
        >
          ✕
        </button>
      </div>
      <div className="mb-reply-message-preview">
        {replyingTo.message || (replyingTo.file_url && "📎 Attachment")}
      </div>
    </div>
  </div>
)}
          

         <form onSubmit={handleSendMessage} className="mb-message-input-form">
  {selectedFile && (
    <div className="mb-file-preview">
      <span className="mb-file-name">
        {selectedFile.name} ({(selectedFile.size / 1024).toFixed(1)} KB)
      </span>
      <button
        type="button"
        className="mb-remove-file"
        onClick={() => {
          setSelectedFile(null);
          if (fileInputRef.current) fileInputRef.current.value = "";
        }}
      >
        ✕
      </button>
    </div>
  )}
  
  <div className="mb-input-container">
    <button
      type="button"
      className="mb-attach-btn"
      onClick={() => fileInputRef.current?.click()}
      disabled={isSending}
    >
      📎
    </button>
    
    <input
      type="file"
      ref={fileInputRef}
      onChange={handleFileSelect}
      style={{ display: "none" }}
      accept="image/*,application/pdf,.doc,.docx,.txt"
    />
    
    <textarea
      className="mb-message-input"
      placeholder="Type your message..."
      value={newMessage}
      onChange={(e) => {
        setNewMessage(e.target.value);
        e.target.style.height = "auto";
        e.target.style.height = e.target.scrollHeight + "px";
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault(); 
          if (!isSending && (newMessage.trim() || selectedFile)) {
            handleSendMessage(e);
          }
        }
      }}
      disabled={isSending}
      rows={1}
    />
    
    <button
      type="submit"
      className="mb-send-btn"
      disabled={isSending || (!newMessage.trim() && !selectedFile)}
    >
      {isSending ? (
        <div className="mb-send-spinner"></div>
      ) : (
        "Send"
      )}
    </button>
  </div>
</form>
        </>
      )}

{selectMode && selectedMessages.size > 0 && (
  <div className="mb-selection-bar">
    <div className="mb-selection-info">
      <button 
        className="mb-selection-cancel-btn"
        onClick={() => {
          setSelectMode(false);
          setSelectedMessages(new Set());
        }}
      >
        <FaTimes />
      </button>
      <span className="mb-selection-count">{selectedMessages.size}</span>
      <span className="mb-selection-text">
       selected
      </span>
    </div>
    <div className="mb-selection-actions">
      <button 
        className="mb-selection-delete-btn"
        onClick={handleBulkDelete}
      >
        <RiDeleteBin6Line size={18} />
      </button>
    </div>
  </div>
)}
{forwardMode && forwardSelectedMessages.size > 0 && (
  <div className="mb-selection-bar">
    <div className="mb-selection-info">
      <button
        className="mb-selection-cancel-btn"
        onClick={() => {
          setForwardMode(false);
          setForwardSelectedMessages(new Set());
        }}
      >
        <FaTimes />
      </button>

      <span className="mb-selection-count">
        {forwardSelectedMessages.size}
      </span>
      <span className="mb-selection-text">selected</span>
    </div>

    <div className="mb-selection-actions">
      <button
        className="mb-selection-forward-btn"
        onClick={() => {
          setForwardModal({ show: true });
          fetchContacts();
        }}
      >
        <FiCornerUpRight size={18} />
      </button>
    </div>
  </div>
)}
{contextMenu.show && (
  <div 
    className="mb-context-menu"
    style={{ 
      position: 'fixed', 
       top: contextMenu.y, 
        left: contextMenu.isSender ? 'auto' : contextMenu.x,
       right: contextMenu.isSender ? window.innerWidth - contextMenu.x : 'auto',
      zIndex: 1000
    }}
    onClick={(e) => e.stopPropagation()}
  >
    <div className="mb-context-menu-content">
      <button onClick={() => handleReplyTo(contextMenu.message)} className="mb-context-item">
        <GoReply />  Reply
      </button>
      <button onClick={() => handleCopyMessage(contextMenu.message)} className="mb-context-item">
        <MdContentCopy /> Copy
      </button>
      <button onClick={() => handleForwardMessage(contextMenu.message)} className="mb-context-item">
        <FiCornerUpRight />  Forward
      </button>
      
      {contextMenu.message?.sender?.toLowerCase().trim() === currentUserName?.toLowerCase().trim() && 
       !contextMenu.message?.file_url && (
        <button onClick={() => handleEditMessage(contextMenu.message)} className="mb-context-item">
          <MdOutlineEdit /> Edit
        </button>
      )}
      
      {userRole === "superadmin" && (
        <button onClick={() => handleDeleteMessage(contextMenu.message)} className="mb-context-item mb-delete-item">
          <RiDeleteBin6Line /> Delete
        </button>
      )}
    </div>
  </div>
)}

{contextMenu.show && (
  <div 
    className="mb-context-overlay"
    onClick={closeContextMenu}
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 999
    }}
  />
)}
 
{forwardModal.show && (
  <div className="mb-modal-overlay" onClick={() => setForwardModal({ show: false, message: null })}>
    <div className="mb-forward-modal-content" onClick={(e) => e.stopPropagation()}>
      <div className="mb-forward-modal-header">
        <h3>Forward message to</h3>
        <button 
          className="mb-forward-modal-close" 
          onClick={() => setForwardModal({ show: false, message: null })}
        >
          ✕
        </button>
      </div>
      
      <div className="mb-forward-search">
        <input
          type="text"
          className="mb-forward-search-input"
          placeholder="Search name or email"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          autoFocus
        />
      </div>
      
     <div className="mb-forward-contacts-list">
  {filteredContacts.length === 0 ? (
    <div className="mb-no-contacts">
      <p>No contacts found</p>
    </div>
  ) : (
    filteredContacts.map(contact => (
 <div
  key={contact.id}
  className={`mb-forward-contact-item ${
    [...selectedContacts].some(c => c.id === contact.id) ? 'mb-selected' : ''
  }`}
  onClick={() => toggleContactSelection(contact)}
>
  <div className="mb-contact-checkbox">
    <input
      type="checkbox"
      checked={[...selectedContacts].some(c => c.id === contact.id)}
      onChange={() => toggleContactSelection(contact)}  
      onClick={(e) => e.stopPropagation()} 
    />
  </div>

  <div
    className="mb-forward-contact-avatar"
    style={{ background: getAvatarColor(contact.name || contact.email) }}
  >
    {contact.avatar}
  </div>

  <div className="mb-forward-contact-info">
    <div className="mb-forward-contact-name">
      {contact.name || "Unknown"}
    </div>
    <div className="mb-forward-contact-email">
      {contact.email || "No email"}
    </div>
  </div>
</div>
    ))
  )}
</div>
      
      <div className="mb-forward-message-preview">
      </div>
      
      <div className="mb-forward-modal-footer">
        <button 
          className="mb-forward-modal-cancel" 
          onClick={() => setForwardModal({ show: false, message: null })}
        >
          Cancel
        </button>
        <button 
          className="mb-forward-modal-send" 
          onClick={sendForwardMessage}
          disabled={selectedContacts.size === 0 || isForwarding}
        >
          {isForwarding ? "Forwarding..." : "Forward"}
        </button>
      </div>
    </div>
  </div>
)}

{editModal.show && (
  <div className="mb-modal-overlay" onClick={handleCancelEditModal}>
    <div className="mb-edit-modal-content" onClick={(e) => e.stopPropagation()}>
      <div className="mb-edit-modal-header">
        <h3>Edit Message</h3>
        <button className="mb-edit-modal-close" onClick={handleCancelEditModal}>✕</button>
      </div>
      
      <div className="mb-edit-modal-body">
        <textarea
          className="mb-edit-textarea"
          value={editModal.text}
          onChange={(e) => setEditModal({ ...editModal, text: e.target.value })}
          autoFocus
          rows="3"
          placeholder="Edit your message..."
        />
      </div>
      
      <div className="mb-edit-modal-footer">
        <button className="mb-edit-modal-cancel" onClick={handleCancelEditModal}>
          Cancel
        </button>
        <button 
          className="mb-edit-modal-save" 
          onClick={handleSaveEditFromModal}
          disabled={!editModal.text.trim()}
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
)}

{deleteModal.show && (
  <div className="mb-modal-overlay" onClick={handleCancelDelete}>
    <div className="mb-delete-modal-content" onClick={(e) => e.stopPropagation()}>
      <div className="mb-delete-modal-header">
        <h3>Delete Message</h3>
        <button className="mb-delete-modal-close" onClick={handleCancelDelete}>✕</button>
      </div>
      
      <div className="mb-delete-modal-body">
        <p>Are you sure you want to delete this message?</p>
        <div className="mb-delete-message-preview">
          <strong>Message:</strong>
          <p>{deleteModal.message?.message || (deleteModal.message?.file_url ? "📎 File attachment" : "")}</p>
        </div>
      </div>
      
      <div className="mb-delete-modal-footer">
        <button className="mb-delete-modal-cancel" onClick={handleCancelDelete}>
          Cancel
        </button>
        <button className="mb-delete-modal-confirm" onClick={handleConfirmDelete}>
          Delete
        </button>
      </div>
    </div>
  </div>
)}

{showBulkDeleteConfirm && (
  <div className="mb-modal-overlay" onClick={cancelBulkDelete}>
    <div className="mb-delete-modal-content" onClick={(e) => e.stopPropagation()}>
      <div className="mb-delete-modal-header">
        <h3>Delete Messages</h3>
        <button className="mb-delete-modal-close" onClick={cancelBulkDelete}>✕</button>
      </div>
      
      <div className="mb-delete-modal-body">
        <p>Are you sure you want to delete <strong>{selectedMessages.size}</strong> message{selectedMessages.size > 1 ? 's' : ''}?</p>
      </div>
      
      <div className="mb-delete-modal-footer">
        <button className="mb-delete-modal-cancel" onClick={cancelBulkDelete}>
          Cancel
        </button>
        <button className="mb-delete-modal-confirm" onClick={confirmBulkDelete}>
          Delete {selectedMessages.size > 1 ? 'All' : ''}
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
});

export default MessageBox;